/**
 * React Query keys used in more than one place, shared by web and mobile, so
 * the component that reads a key and the ones that set or invalidate it
 * cannot drift apart (a rename can't silently break the invalidation).
 */

/** The conversation list (infinite query; see hooks/useConversationsQuery). */
export const CONVERSATIONS_KEY = ['conversations'];

/** Unread notifications — the bell's badge. Set live from the socket. */
export const NOTIFICATIONS_UNREAD_KEY = ['notifications', 'unreadCount'];

/** Conversations with an unread message — the header's chat badge. */
export const UNREAD_MESSAGES_KEY = ['messages', 'unreadCount'];

/** The signed-in user's server-side preferences (hooks/usePreference). */
export const PREFERENCES_KEY = ['users', 'preferences'];

/** Whether this device opted in to mood tracking (hooks/useMoodTracking). */
export const MOOD_TRACKING_KEY = ['moodTrackingEnabled'];
